/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
// Mirror (9/21/26): what the search panel shows before you type, and when nothing matches.
// Popular searches = the real top terms from Shopify's search report (90 days), kept to ones with strong in-stock results.
// Trending = the homepage sneaker wall picks + Jellycat + the top-selling OAS shirt (Shopify product ids; the products endpoint wants ids, not handles).
var boostPFSPopularSearches = ['Jellycat', 'adidas', 'Samba', 'On Cloud', 'New Balance', 'Free People', 'Malbon', 'Oncept'];
var boostPFSTrendingProducts = [9116737077502, 9267920437502, 9334350414078, 9380925210878, 8768388202750, 7594710106366];
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
        searchBoxOnclick: {
            recentSearch: { label: 'Recent searches', status: true, number: 3 },
            searchTermSuggestion: { label: 'Popular searches', status: true, type: 'manually', data: boostPFSPopularSearches, backup: [] },
            productSuggestion: { label: 'Trending now', status: true, type: 'manually', data: boostPFSTrendingProducts, backup: [] }
        },
        // No-result suggestions: the lists come from the Boost admin (Search → Search results page → "Search page
        // without results": manual terms + "Trending now" products, set 9/21/26) but the app config ships them
        // with status:false, so the panel showed a bare "nothing found" (9/27). Switched on here; data stays in the admin.
        suggestionNoResult: {
            search_terms: { status: true },
            products: { status: true }
        }
    },
    label: {
        suggestion: {
            searchBoxOnclickRecentSearchLabel: 'Recent searches',
            searchBoxOnclickSearchTermLabel: 'Popular searches',
            searchBoxOnclickProductsLabel: 'Trending now',
            noSearchResultSearchTermLabel: 'Try one of these',
            noSearchResultProductsLabel: 'Trending now'
        }
    },
    // Boost merges the app's per-locale labels AFTER this file, so `label` alone still rendered
    // "Trending products" (found 9/27). The locale copy has to say it too.
    labelTranslations: {
        en: {
            suggestion: {
                searchBoxOnclickRecentSearchLabel: 'Recent searches',
                searchBoxOnclickSearchTermLabel: 'Popular searches',
                searchBoxOnclickProductsLabel: 'Trending now',
                noSearchResultSearchTermLabel: 'Try one of these',
                noSearchResultProductsLabel: 'Trending now'
            }
        }
    }
};

(function() {
    BoostPFS.inject(this);
    InstantSearchApi.beforeCall = function(searchTerm) {
        Globals.instantSearchQueryParams.country = Shopify.country;
        Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
        Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
        Globals.instantSearchQueryParams.return_all_currency_fields = false;
    }
    // Clear button for the Form Search
    HTMLDocument.prototype.ready = function() {
        return new Promise(function(resolve, reject) {
            if (document.readyState === 'complete') {
                resolve(document);
            } else {
                document.addEventListener('DOMContentLoaded', function() {
                    resolve(document);
                });
            }
        });
    }
    document.ready().then(function() {
        var inputSearchFormSelector = jQ('.boost-pfs-search-input');
        var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');
        if (!!inputSearchFormSelector.val()) {
            clearSearchFormSelector.show();
        }
        inputSearchFormSelector.on('change keydown keyup', function() {
            if (!!jQ(this).val()) {
                clearSearchFormSelector.show();
            } else {
                clearSearchFormSelector.hide();
            }
        })
        clearSearchFormSelector.on("click", function() {
            inputSearchFormSelector.val("");
            jQ(this).hide();
            inputSearchFormSelector.click();
        });
    }) // End Clear button for the Form Search
    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };
    // Bind Event for input search Mobile
    var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
    InstantSearchMobile.prototype.bindEvents = function() {
        bindEventsMobile.call(this);
        var self = this;
        var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
        var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
        var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
        jQ(searchButtonMobile).off('click').click(function(e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputMobile).focus();
            self.openSuggestionMobile();
            jQ(searchCloseButtonMobile).trigger('click');
        });
    }
    // Bind Event for input search style 3
    var bindEvents = InstantSearchStyle3.prototype.bindEvents;
    InstantSearchStyle3.prototype.bindEvents = function() {
        bindEvents.call(this);
        var self = this;
        var searchButtonDesktop = '.site-header__links .search-button';
        var searchInputDesktop = '#SearchContainer #search-input';
        var searchCloseButtonDesktop = '.drawer__close > button';
        jQ(searchButtonDesktop).off('click').click(function(e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputDesktop).focus();
            self.openSuggestionStyle3();
            jQ(searchCloseButtonDesktop).trigger('click');
        });
    }
    // Fix search for the Flow theme
    jQ('.site-header__links .search-button').on('click', function() {
        setTimeout(function() {
            boostPFS.initSearchBox();
            if (Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
        }, 500);
    });
})();

// Mirror (9/27/26): Boost renders 200px thumbnails; the panel now shows them as ~260px cards (2x on retina).
// Swap in the 480px rendition as items appear.
(function () {
    function upsize(root) {
        (root.querySelectorAll ? root.querySelectorAll('.boost-pfs-search-suggestion-item-product img[src*="_200x."]') : []).forEach(function (img) {
            img.src = img.src.replace('_200x.', '_480x.');
        });
    }
    if (typeof MutationObserver === 'undefined') return;
    // 10/1: only nodes inside a Boost suggestion wrapper are upsized; everything else on the page is ignored cheaply.
    new MutationObserver(function (muts) {
        muts.forEach(function (m) { if (!m.target || !m.target.closest || !m.target.closest('.boost-pfs-search-suggestion-wrapper')) return; m.addedNodes.forEach(function (n) { if (n.nodeType === 1) upsize(n); }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
})();

SearchInput.prototype._onFocusSearchBox = function(event) {
    // Mirror (9/27/26): on desktop the header's Search button focuses the box programmatically, and Boost
    // only shows the on-click panel (recent / popular / trending) on a real click — so the panel sat blank
    // until you typed. Treat focus on an empty box like a click. (9/21 note: openSuggestion() doesn't exist
    // in this core; the old guard is gone.)
    var ac = this.searchAutoComplete;
    if (!ac || !ac.enableOnClickSearchBox) return;
    if (this.$element && this.$element.val()) return;
    if (typeof ac._onOpen === 'function') ac._onOpen();
    else if (typeof ac.showOnClickSuggestion === 'function') ac.showOnClickSuggestion();
};
